/* GRATU — Página de producto. Sin dependencias. */
(() => {
  if (window.__gratuPdp) return;
  window.__gratuPdp = true;

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  /* ---------- Formato de moneda con el formato de la tienda ---------- */
  function money(cents, format) {
    const fmt = format || '${{amount_no_decimals_with_comma_separator}}';
    const group = (n, d, t) => n.replace(/\B(?=(\d{3})+(?!\d))/g, t);
    const v = Number(cents) / 100;
    const out = {
      amount: () => group(v.toFixed(2).split('.')[0], 2, ',') + '.' + v.toFixed(2).split('.')[1],
      amount_no_decimals: () => group(Math.round(v).toString(), 0, ','),
      amount_with_comma_separator: () => group(v.toFixed(2).split('.')[0], 2, '.') + ',' + v.toFixed(2).split('.')[1],
      amount_no_decimals_with_comma_separator: () => group(Math.round(v).toString(), 0, '.'),
      amount_with_apostrophe_separator: () => group(v.toFixed(2).split('.')[0], 2, "'") + '.' + v.toFixed(2).split('.')[1],
      amount_no_decimals_with_space_separator: () => group(Math.round(v).toString(), 0, ' ')
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => (out[k] || out.amount)());
  }

  /* ---------- Packs: precio por unidad según la regla (ninguno | porcentaje | monto en pesos) ---------- */
  function packUnit(base, pk) {
    if (pk.tipo === 'porcentaje') return base - Math.floor(base * pk.valor / 100);
    if (pk.tipo === 'monto') return base - pk.valor * 100;
    if (pk.price) return pk.price * 100 / pk.qty; // formato antiguo
    return base;
  }

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(root, html) {
    const t = (root && $('[data-gp-toast]', root)) || $('[data-gp-toast]');
    if (!t) return;
    t.innerHTML = html;
    t.classList.add('is-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove('is-show'), 3200);
  }

  /* ---------- Carrito: integración con Tinker/Horizon (evento cart:update) ---------- */
  async function addToCart(items, root, label, form) {
    const cartSections = [...document.querySelectorAll('cart-items-component[data-section-id]')]
      .map(el => el.dataset.sectionId).filter(Boolean);
    const base = (window.Theme && Theme.routes && Theme.routes.root) || (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    let body, headers = {Accept: 'application/json'};
    if (form) {
      // Envía el formulario completo: incluye campos que agregan apps como Kaching Bundles
      body = new FormData(form);
      [...body.keys()].filter(k => /kaching/i.test(k)).forEach(k => body.delete(k));
      // La cantidad del pack sale del estado de la sección (otras apps pueden reescribir el input)
      if (root && root.__gpQty) body.set('quantity', String(root.__gpQty));
      if (cartSections.length) body.append('sections', cartSections.join(','));
    } else {
      body = JSON.stringify(cartSections.length ? {items, sections: cartSections.join(',')} : {items});
      headers['Content-Type'] = 'application/json';
    }
    const res = await fetch(base + 'cart/add.js', {method: 'POST', headers, body});
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || 'No se pudo agregar');

    // El tema escucha 'cart:update': actualiza burbuja, re-dibuja el carrito y abre el drawer (si auto-open)
    const qty = form ? Number((root && root.__gpQty) || new FormData(form).get('quantity') || 1) : items.reduce((n, it) => n + (it.quantity || 1), 0);
    const ev = new Event('cart:update', {bubbles: true});
    ev.detail = {resource: {}, sourceId: String(form ? new FormData(form).get('id') : items[0].id), data: {
      source: 'product-form-component', itemCount: qty, sections: data.sections,
      productId: root && root.__gp ? String(root.__gp.productId) : undefined
    }};
    document.dispatchEvent(ev);

    const drawer = document.querySelector('cart-drawer-component');
    if (drawer && !drawer.hasAttribute('auto-open') && typeof drawer.open === 'function') drawer.open();
    if (!drawer) {
      const cartUrl = root && root.__gp ? root.__gp.cartUrl : '/cart';
      toast(root, `Agregado: ${label} <a href="${cartUrl}">Ver carrito</a>`);
    }
    return data;
  }

  /* ---------- Sección principal ---------- */
  function initMain(root) {
    const D = JSON.parse($('[data-gp-json]', root).textContent);
    root.__gp = D;
    const fmt = c => money(c, D.moneyFormat);

    // Galería en el orden del Admin de Shopify (posiciones 1-based)
    const all = D.images;
    // Orden = el de Shopify Admin (foto #1 primero)
    const order = all.map((_, i) => i + 1);
    const studio = new Set(D.studio || []);
    const imgs = order.map(p => ({...all[p - 1], pos: p, studio: studio.has(p)}));
    const posToIdx = p => { const i = imgs.findIndex(x => x.pos === p); return i < 0 ? null : i; };

    const main = $('[data-gp-main-img]', root), thumbs = $('[data-gp-thumbs]', root);
    const track = $('[data-gp-mtrack]', root), dots = $('[data-gp-mdots]', root);
    let cur = 0;
    imgs.forEach((im, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Ver imagen ' + (i + 1));
      b.innerHTML = `<img src="${im.thumb}" alt="" loading="lazy"${im.studio ? ' class="is-studio"' : ''}>`;
      b.onclick = () => show(i);
      thumbs.appendChild(b);
      const m = document.createElement('img');
      m.src = im.src; m.alt = im.alt || D.title;
      if (im.studio) m.className = 'is-studio';
      if (i) m.loading = 'lazy';
      track.appendChild(m);
      dots.appendChild(document.createElement('i'));
    });
    function show(i, instant) {
      if (!imgs.length || !main) return;
      cur = (i + imgs.length) % imgs.length;
      const apply = () => { main.src = imgs[cur].src; main.alt = imgs[cur].alt || D.title; main.classList.toggle('is-studio', imgs[cur].studio); main.style.opacity = 1; };
      if (instant) apply(); else { main.style.opacity = 0; setTimeout(apply, 150); }
      [...thumbs.children].forEach((t, k) => t.classList.toggle('is-on', k === cur));
    }
    $('[data-gp-prev]', root).onclick = () => show(cur - 1);
    $('[data-gp-next]', root).onclick = () => show(cur + 1);
    if (imgs.length < 2) $$('[data-gp-prev],[data-gp-next],[data-gp-mdots]', root).forEach(el => el.hidden = true);
    track.addEventListener('scroll', () => {
      const k = Math.round(track.scrollLeft / track.clientWidth);
      [...dots.children].forEach((d, j) => d.classList.toggle('is-on', j === k));
    }, {passive: true});

    // Variantes
    const byId = id => D.variants.find(v => v.id === id);
    let sel = (byId(D.current) || D.variants[0]).o.slice();
    let pack = 0;
    let units = []; // variante elegida para cada unidad del pack
    let cartCents = 0, lastSelection = 0, lastName = '', inCart = false;
    const fsBox = $('[data-gp-fs]', root);
    const esc = t => String(t || '').replace(/[&<>"]/g, ch => ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;'}[ch]));
    function updateFS(selection, name) {
      if (!fsBox) return;
      lastSelection = selection;
      if (name != null) lastName = name;
      const th = Number(fsBox.dataset.threshold);
      const t = $('[data-gp-fs-text]', root), bar = $('[data-gp-fs-bar]', root);
      // Si el producto ya está en el carrito, se mide solo el carrito; si no, carrito + lo que está eligiendo
      const total = inCart ? cartCents : cartCents + selection;
      const missing = th - total;
      if (inCart) {
        t.innerHTML = missing > 0
          ? `Te faltan <b>${fmt(missing)}</b> para obtener <b>envío gratis</b>`
          : '<b>¡Tu pedido ya tiene envío gratis!</b>';
      } else {
        t.innerHTML = missing > 0
          ? `Comprando este <b>${esc(lastName)}</b> te faltarían <b>${fmt(missing)}</b> para obtener <b>envío gratis</b>`
          : `Comprando este <b>${esc(lastName)}</b> tu envío es <b>gratis</b>`;
      }
      fsBox.classList.toggle('is-done', missing <= 0);
      bar.style.width = Math.min(100, Math.round(total * 100 / th)) + '%';
      fsBox.hidden = false;
    }
    const refreshCart = () => fetch(((window.Theme && Theme.routes && Theme.routes.root) || '/') + 'cart.js')
      .then(r => r.json()).then(c => {
        cartCents = c.total_price || 0;
        inCart = (c.items || []).some(i => String(i.product_id) === String(D.productId));
        updateFS(lastSelection);
      }).catch(() => {});
    refreshCart();
    document.addEventListener('cart:update', () => setTimeout(refreshCart, 400));
    const singleOption = D.hasOptions && D.variants[0].o.length === 1;
    const unitNoun = /planeador/i.test(D.title) ? 'Planeador' : 'Unidad';
    const hexFor = val => {
      const band = root.querySelector(`[data-gp-opt="0"][data-gp-val="${CSS.escape(val)}"] .gp-band`);
      return band ? band.style.background : null;
    };
    const visibleVal = val => !!root.querySelector(`[data-gp-opt="0"][data-gp-val="${CSS.escape(val)}"]`);
    const unitsActive = () => D.packs && D.packs.length && D.hasOptions && D.packs[pack].qty > 1;
    const find = s => D.variants.find(v => v.o.every((x, k) => x === s[k]));
    const anyAvail = (k, val) => D.variants.some(v => v.avail && v.o[k] === val && v.o.every((x, j) => j === k || x === sel[j]));
    const imgFor = v => {
      if (D.byOption) for (const val of v.o) if (D.byOption[val] != null) { const i = posToIdx(D.byOption[val]); if (i != null) return i; }
      return v.img != null ? posToIdx(v.img) : null;
    };

    const idInput = $('[data-gp-variant]', root), qtyInput = $('[data-gp-qty]', root);
    const err = $('[data-gp-error]', root);

    function render(moveImage) {
      const v = find(sel) || D.variants[0];
      let price = v.price, cmp = v.cmp;
      if (D.packs && D.packs.length) {
        const pk = D.packs[pack];
        price = packUnit(v.price, pk) * pk.qty;
        // 1 unidad: precio tachado del producto · pack: contra lo que costarían las unidades sueltas
        cmp = pk.qty === 1 ? v.cmp : v.price * pk.qty;
        // Chips: c/u y ahorro desde el precio actual de la variante
        $$('[data-gp-pack]', root).forEach(c => {
          const p = D.packs[+c.dataset.gpPack], u = packUnit(v.price, p), sv = (v.price - u) * p.qty;
          const ue = c.querySelector('[data-gp-pack-unit]'), se = c.querySelector('[data-gp-pack-save]');
          if (ue) ue.textContent = fmt(u) + ' c/u';
          if (se) { se.textContent = `Ahorra ${fmt(sv)} · ${Math.floor(sv * 100 / v.price / p.qty)}%`; se.hidden = sv <= 0; }
        });
      }

      $$('[data-gp-opt]', root).forEach(c => {
        const k = +c.dataset.gpOpt, val = c.dataset.gpVal;
        c.classList.toggle('is-on', sel[k] === val);
        c.classList.toggle('is-out', !anyAvail(k, val));
      });
      $$('[data-gp-optname]', root).forEach(b => { b.textContent = sel[+b.dataset.gpOptname]; });

      $('[data-gp-price]', root).textContent = fmt(price);
      const c = $('[data-gp-cmp]', root), off = $('[data-gp-off]', root);
      const sav = $('[data-gp-saving]', root);
      if (cmp > price) {
        const pct = Math.floor((cmp - price) * 100 / cmp);
        c.textContent = fmt(cmp); off.textContent = '-' + pct + '%'; c.hidden = off.hidden = false;
        if (sav) {
          const esc = t => String(t || '').replace(/[&<>"]/g, ch => ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;'}[ch]));
          sav.innerHTML = `<i class="gp-pulse" aria-hidden="true"></i>${esc(D.savingPrefix)} <b>${esc(D.savingHighlight)}</b> <span>${fmt(cmp - price)} (${pct}%)</span>`;
          sav.hidden = false;
        }
      } else { c.hidden = off.hidden = true; if (sav) sav.hidden = true; }

      const extras = $$('[data-gp-upsell]:checked', root);
      const extrasTotal = extras.reduce((n, x) => n + Number(x.dataset.price || 0), 0);
      {
        const pk = D.packs && D.packs.length ? D.packs[pack] : null;
        let name = pk && pk.qty > 1 ? `${pk.t} de ${D.title}` : D.title;
        if (extras.length) name += ` + ${extras.length} ${extras.length === 1 ? 'bloc' : 'blocs'}`;
        updateFS(v.avail ? price + extrasTotal : 0, name);
      }
      $$('[data-gp-atc]', root).forEach(b => {
        b.disabled = !v.avail;
        // Con apps de combos (Kaching) el precio lo define el combo elegido: no lo mostramos en el botón
        const bundleApp = !(D.packs && D.packs.length) && root.querySelector('kaching-bundles-block, kaching-bundle');
        b.textContent = v.avail ? (bundleApp ? D.atcLabel : `${D.atcLabel} — ${fmt(price + extrasTotal)}`) : D.soldoutLabel;
      });
      idInput.value = v.id;
      if (D.packs && D.packs.length) { qtyInput.value = D.packs[pack].qty; root.__gpQty = D.packs[pack].qty; }
      err.hidden = true;

      const parts = D.hasOptions ? sel.slice() : [];
      if (D.packs && D.packs.length) parts.push(D.packs[pack].t);
      $('[data-gp-sticky-v]', root).textContent = parts.join(' · ') || fmt(price);

      const i = imgFor(v);
      if (moveImage && i != null) { show(i); track.scrollTo({left: i * track.clientWidth, behavior: 'smooth'}); }
      const si = $('[data-gp-sticky-img]', root);
      if (si && imgs.length && moveImage) si.src = imgs[i != null ? i : 0].thumb;

      renderUnits(v);
      if (extras.length) {
        const sv = $('[data-gp-sticky-v]', root);
        sv.textContent += ` + ${extras.length} ${extras.length === 1 ? 'bloc' : 'blocs'}`;
      }

      if (moveImage && D.hasOptions) {
        const url = new URL(location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url);
      }
    }

    function renderUnits(v) {
      const box = $('[data-gp-units]', root);
      if (!box) return;
      if (!unitsActive()) { box.hidden = true; units = []; return; }
      const qty = D.packs[pack].qty;
      if (!units.length && D.packs[pack].mix) {
        // Pack mixto: precarga variantes distintas disponibles (ej. los 3 diseños)
        const avail = D.variants.filter(x => x.avail && (!singleOption || visibleVal(x.o[0])));
        for (let i = 0; i < qty && avail.length; i++) units.push(avail[i % avail.length].id);
      }
      while (units.length < qty) units.push(v.id);
      units.length = qty;
      const opts = D.variants.filter(x => !singleOption || visibleVal(x.o[0]));
      const isColor = singleOption && !!hexFor(D.variants[0].o[0]);
      const labelEl = root.querySelector('[data-gp-optname="0"]');
      const optName = labelEl ? labelEl.parentElement.firstChild.textContent.replace(':', '').trim().toLowerCase() : 'opción';
      let html = `<div class="gp-units-title">Elige ${isColor ? 'el color' : 'el ' + optName} de cada ${unitNoun.toLowerCase()}</div>`;
      units.forEach((id, i) => {
        const cur = D.variants.find(x => x.id === id) || v;
        html += `<div class="gp-unit-row${singleOption && !isColor ? ' is-text' : ''}"><span class="gp-unit-name">${unitNoun} ${i + 1} · <b>${cur.o.join(' / ')}</b></span>`;
        if (singleOption && !isColor) {
          html += '<div class="gp-upills">' + opts.map(x => `<button type="button" class="gp-upill${x.id === id ? ' is-on' : ''}" data-gp-unit="${i}" data-gp-unit-v="${x.id}"${x.avail ? '' : ' disabled'}>${x.o[0]}</button>`).join('') + '</div>';
        } else if (singleOption) {
          html += '<div class="gp-sws">' + opts.map(x => `<button type="button" class="gp-sw${x.id === id ? ' is-on' : ''}" data-gp-unit="${i}" data-gp-unit-v="${x.id}" style="background:${hexFor(x.o[0]) || '#ccc'}" aria-label="${unitNoun} ${i + 1}: ${x.o[0]}" title="${x.o[0]}"${x.avail ? '' : ' disabled'}></button>`).join('') + '</div>';
        } else {
          html += `<select data-gp-unit-sel="${i}">` + opts.filter(x => x.avail).map(x => `<option value="${x.id}"${x.id === id ? ' selected' : ''}>${x.o.join(' / ')}</option>`).join('') + '</select>';
        }
        html += '</div>';
      });
      box.innerHTML = html;
      box.hidden = false;
      const summary = units.map(id => (D.variants.find(x => x.id === id) || v).o.join(' / '));
      $('[data-gp-sticky-v]', root).textContent = D.packs[pack].t + ' · ' + summary.join(' + ');
    }
    root.addEventListener('click', e => {
      const b = e.target.closest('[data-gp-unit]');
      if (!b || b.disabled) return;
      units[+b.dataset.gpUnit] = +b.dataset.gpUnitV;
      const uv = D.variants.find(x => x.id === +b.dataset.gpUnitV);
      const i = uv ? imgFor(uv) : null;
      if (i != null) show(i);
      renderUnits(find(sel) || D.variants[0]);
    });
    root.addEventListener('change', e => {
      const s = e.target.closest('[data-gp-unit-sel]');
      if (!s) return;
      units[+s.dataset.gpUnitSel] = +s.value;
      renderUnits(find(sel) || D.variants[0]);
    });

    $$('[data-gp-opt]', root).forEach(c => c.addEventListener('click', () => {
      const k = +c.dataset.gpOpt, val = c.dataset.gpVal;
      sel[k] = val;
      const v = find(sel);
      if (!v || !v.avail) {
        const alt = D.variants.find(x => x.avail && x.o[k] === val);
        if (alt) sel = alt.o.slice();
      }
      units = []; // se re-llenan con el nuevo color
      render(true);
    }));
    $$('[data-gp-upsell]', root).forEach(x => x.addEventListener('change', () => {
      x.closest('.gp-up').classList.toggle('is-on', x.checked);
      render(false);
    }));
    $$('[data-gp-pack]', root).forEach(c => c.addEventListener('click', () => {
      pack = +c.dataset.gpPack;
      units = [];
      $$('[data-gp-pack]', root).forEach(x => x.classList.toggle('is-on', x === c));
      $('[data-gp-packname]', root).textContent = D.packs[pack].t;
      render(false);
    }));

    // Imagen inicial: siempre la #1 del Admin (no la de la variante seleccionada)
    show(0, true);
    render(false);

    // Agregar al carrito
    const form = $('[data-gp-form]', root);
    const submit = async ev => {
      ev && ev.preventDefault();
      const v = find(sel);
      if (!v || !v.avail) return;
      const btns = $$('[data-gp-atc]', root);
      btns.forEach(b => b.classList.add('is-loading'));
      try {
        const extras = $$('[data-gp-upsell]:checked', root).map(x => ({id: +x.value, quantity: 1}));
        if ((unitsActive() && units.length) || extras.length) {
          let items;
          if (unitsActive() && units.length) {
            const counts = {};
            units.forEach(id => { counts[id] = (counts[id] || 0) + 1; });
            items = Object.entries(counts).map(([id, q]) => ({id: +id, quantity: q}));
          } else {
            items = [{id: v.id, quantity: Number(root.__gpQty || qtyInput.value || 1)}];
          }
          await addToCart(items.concat(extras), root, D.title);
          // limpia la selección del upsell tras agregar
          $$('[data-gp-upsell]:checked', root).forEach(x => { x.checked = false; x.closest('.gp-up').classList.remove('is-on'); });
          render(false);
        } else {
          await addToCart(null, root, D.title, form);
        }
      } catch (e) {
        err.textContent = e.message; err.hidden = false;
      } finally {
        btns.forEach(b => b.classList.remove('is-loading'));
      }
    };
    form.addEventListener('submit', submit);
    const stickyBtn = $('[data-gp-sticky] [data-gp-atc]', root);
    stickyBtn.addEventListener('click', submit);

    // Barra sticky
    const sticky = $('[data-gp-sticky]', root);
    new IntersectionObserver(([en]) => {
      sticky.classList.toggle('is-show', !en.isIntersecting && en.boundingClientRect.top < 0);
    }).observe($('[data-gp-form] [data-gp-atc]', root));
  }

  /* ---------- Agregado rápido en relacionados ---------- */
  document.addEventListener('click', async ev => {
    const b = ev.target.closest('[data-gp-quick]');
    if (!b) return;
    ev.preventDefault(); ev.stopPropagation();
    const root = document.querySelector('[data-gp-main]');
    b.disabled = true;
    try { await addToCart([{id: +b.dataset.gpQuick, quantity: 1}], root, b.dataset.gpName); }
    catch (e) { toast(root, e.message); }
    finally { b.disabled = false; }
  });

  /* ---------- Carrusel de testimonios ---------- */
  function initQuotes(root) {
    const q = $('[data-gp-track]', root);
    if (!q) return;
    const step = () => (q.firstElementChild ? q.firstElementChild.offsetWidth + 20 : 300);
    const p = $('[data-gp-qprev]', root), n = $('[data-gp-qnext]', root);
    if (p) p.onclick = () => q.scrollBy({left: -step(), behavior: 'smooth'});
    if (n) n.onclick = () => q.scrollBy({left: step(), behavior: 'smooth'});
  }

  /* ---------- Aparición suave ---------- */
  const io = 'IntersectionObserver' in window
    ? new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), {threshold: .12})
    : null;
  const reveal = r => $$('.gp-reveal', r).forEach(el => io ? io.observe(el) : el.classList.add('is-in'));

  function boot(scope = document) {
    $$('[data-gp-main]', scope).forEach(r => { if (!r.__gpInit) { r.__gpInit = true; initMain(r); } });
    $$('[data-gp-quotes]', scope).forEach(initQuotes);
    reveal(scope);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
  // Editor de temas: re-inicializa al recargar secciones
  document.addEventListener('shopify:section:load', e => boot(e.target));
})();
